import React from 'react';
import tw, { styled } from 'twin.macro';
import { XCircle } from '@phosphor-icons/react';
import { AdChannel, AdPlacement } from 'types/adTypes';
import { AdVariant } from 'types/adEditorTypes';
import { getFormattedChannel } from 'utils/adEditorHelpers';

interface NonSupportedPreviewProps {
  channel: AdChannel;
  variant: AdVariant;
}

const NonSupportedPreview: React.FC<NonSupportedPreviewProps> = ({
  channel,
  variant,
}) => {
  const getPlacementName = (placement: AdPlacement) => {
    switch (placement) {
      case AdPlacement.FEED:
        return 'Feed';
      case AdPlacement.STORIES:
        return 'Stories';
      case AdPlacement.REELS:
        return 'Reels';
      default:
        return placement;
    }
  };

  return (
    <Container>
      <IconContainer>
        <XCircle size={48} weight="fill" color="#ef4444" />
      </IconContainer>
      <Title>Not Supported</Title>
      <Message>
        {getFormattedChannel(channel)} does not support{' '}
        {getPlacementName(variant.placement)} ads.
      </Message>
      <SubMessage>
        Try switching to a different placement or channel to preview your ad.
      </SubMessage>
    </Container>
  );
};

const Container = styled.div`
  ${tw`flex flex-col items-center justify-center p-8 bg-gray-50 border-2 border-dashed border-gray-300 rounded-lg min-h-[600px] max-w-[400px] mx-auto`}
`;

const IconContainer = styled.div`
  ${tw`mb-4`}
`;

const Title = styled.h3`
  ${tw`text-xl font-semibold text-gray-800 mb-2`}
`;

const Message = styled.p`
  ${tw`text-base text-gray-600 text-center mb-2`}
`;

const SubMessage = styled.p`
  ${tw`text-sm text-gray-500 text-center`}
`;

export default NonSupportedPreview;
